import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  MessageSelection,
  GlobalActions,
  LocationHelper,
  VibeIcon,
  VibeButton,
  viClose,
  viAdd,
  color,
} from 'vibeguide';
import './LoopSelfPromoMessages.scss';

class LoopSelfPromoMessages extends PureComponent {
  constructor(props) {
    super(props);

    const {
      messages,
    } = props;

    this.state = {
      assignedMessages: messages,
    };
  }

  /**
   * When the messages are changed
   */
  onChange = (messages) => {
    const {
      onUpdate,
    } = this.props;

    // Keep sequence in sync with the table order
    const orderedMessages = messages.map((message, i) => ({
      ...message,
      sequence: i,
    }));

    this.setState({
      assignedMessages: orderedMessages,
    });

    onUpdate({
      messages: orderedMessages,
    });
  };

  /**
   * When the Assign Messages button is clicked
   */
  onToggleAddMessages = () => {
    const {
      setPanel,
      onCloseAvailable,
      locations,
    } = this.props;

    const {
      assignedMessages,
    } = this.state;

    // Group the location spec for the location filter
    const group = LocationHelper.group(locations);

    const filters = {
      active: true,
      locations: {
        matchType: 'intersect',
        locations: group,
      },
      mediaFormat: 'visual',
    };

    setPanel({
      thirdPanel: {
        width: window.innerWidth,
        show: true,
        children: (
          <MessageSelection
            columns={[
              'Message Name',
              'Media Format',
              'Company',
              'Requester',
              'Duration',
              '...',
            ]}
            filters={filters}
            selected={assignedMessages}
            customToolbar={(
              <VibeIcon
                className="close"
                icon={viClose}
                color={color.white}
                hoverColor={color.white}
                size={24}
                onClick={onCloseAvailable}
                data-testid="loop-message-selection-close-button"
              />
            )}
            assigning
            allowChanges
            onChange={this.onChange}
          />
        ),
      },
    });
  };

  render() {
    const {
      allowChanges,
      onCloseAssigned,
    } = this.props;

    const {
      assignedMessages,
    } = this.state;

    return (
      <div className="LoopSelfPromoMessages">
        <MessageSelection
          columns={[
            'Message Name',
            'Media Format',
            'Company',
            'Requester',
            'Duration',
            '...',
          ]}
          emptyTitle="No Messages Assigned"
          emptyDescription="This object has not been assigned any messages."
          selected={assignedMessages}
          allowCustomOrder={allowChanges}
          customToolbar={(
            <div className="assigned-toolbar">
              {allowChanges && (
                <VibeButton
                  text="Assign Messages"
                  color="primary"
                  variant="outlined"
                  icon={viAdd}
                  testId="loop-assign-messages-button"
                  onClick={this.onToggleAddMessages}
                />
              )}

              <VibeIcon
                className="close"
                icon={viClose}
                color={color.manatee}
                hoverColor={color.obsidian}
                size={24}
                onClick={onCloseAssigned}
                data-testid="loop-self-promo-messages-close-button"
              />
            </div>
          )}
          allowChanges={allowChanges}
          onChange={this.onChange}
        />
      </div>
    );
  }
}

LoopSelfPromoMessages.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape({
    companyId: PropTypes.string,
    locationId: PropTypes.string,
  })),
  messages: PropTypes.arrayOf(PropTypes.object),
  /** Allow changes to the message selection */
  allowChanges: PropTypes.bool,
  /** When the assigned messages panel is closed */
  onCloseAssigned: PropTypes.func,
  /** When the available messages panel is closed */
  onCloseAvailable: PropTypes.func,
  onUpdate: PropTypes.func,
};

LoopSelfPromoMessages.defaultProps = {
  locations: [],
  messages: [],
  allowChanges: false,
  onCloseAssigned: () => {},
  onCloseAvailable: () => {},
  onUpdate: () => {},
};

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default connect(null, mapDispatchToProps)(LoopSelfPromoMessages);
